import React from "react";
import Header from "../core/Header";
import Footer from "../core/Footer";
import storeImage from "../node/img/store.jpg";
import "./Store.css";

const stories = ["Drops", "New", "Summer", "Limited", "Sneakers", "Bags"];

const products = [
  { name: "Pulse Sneakers", price: "$89", tone: "tone-pink" },
  { name: "Luma Hoodie", price: "$64", tone: "tone-orange" },
  { name: "Grid Crossbody", price: "$52", tone: "tone-blue" },
  { name: "Nova Shades", price: "$39", tone: "tone-yellow" },
  { name: "Studio Tee", price: "$34", tone: "tone-green" },
  { name: "Wave Cap", price: "$24", tone: "tone-purple" }
];

const Store = () => {
  return (
    <div>
      <Header />
      <main className="insta-store">
        <section className="store-hero">
          <div>
            <p className="store-eyebrow">KENNASHKA SHOP</p>
            <h2>Kennashka Shopping Store</h2>
            <p className="store-subtitle">
              Discover curated drops with a social feed vibe.
            </p>
          </div>
          <img src={storeImage} alt="Featured fashion product" />
        </section>

        <section className="store-stories" aria-label="Store stories">
          {stories.map((story) => (
            <div key={story} className="story-pill">
              <span>{story}</span>
            </div>
          ))}
        </section>

        <section className="store-grid">
          {products.map((product) => (
            <article key={product.name} className={`product-card ${product.tone}`}>
              <div className="product-image">♡</div>
              <h3>{product.name}</h3>
              <p>{product.price}</p>
              <button type="button">Add to cart</button>
            </article>
          ))}
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Store;
